if (!customElements.get('recently-viewed')) {
  class RecentlyViewed extends HTMLElement {
    connectedCallback() {
      this.refresh = () => this.init();
      window.addEventListener('pageshow', this.refresh);
      window.addEventListener('storage', this.refresh);
      this.init();
    }

    disconnectedCallback() {
      window.removeEventListener('pageshow', this.refresh);
      window.removeEventListener('storage', this.refresh);
      this.controller?.abort();
    }

    bindTouchScroll() {
      const slider = this.querySelector('.slider');
      if (!slider) return;
      let gesture;
      let suppressClickUntil = 0;
      const finish = () => {
        if (gesture?.horizontal) suppressClickUntil = Date.now() + 700;
        gesture = undefined;
        slider.classList.remove('st-touch-dragging');
      };
      slider.addEventListener('touchstart', (event) => {
        suppressClickUntil = 0;
        if (event.touches.length !== 1) { finish(); return; }
        const touch = event.touches[0];
        gesture = { x: touch.clientX, y: touch.clientY, left: slider.scrollLeft };
      }, { passive: true });
      slider.addEventListener('touchmove', (event) => {
        if (!gesture || event.touches.length !== 1) return;
        const dx = gesture.x - event.touches[0].clientX;
        const dy = gesture.y - event.touches[0].clientY;
        if (!gesture.horizontal) {
          if (Math.max(Math.abs(dx), Math.abs(dy)) < 10) return;
          if (Math.abs(dx) <= Math.abs(dy) * 1.2) { gesture = undefined; return; }
          if (slider.scrollWidth <= slider.clientWidth + 1) { gesture = undefined; return; }
          gesture.horizontal = true;
          slider.classList.add('st-touch-dragging');
        }
        if (event.cancelable) event.preventDefault();
        slider.scrollLeft = gesture.left + dx;
      }, { passive: false });
      slider.addEventListener('touchend', finish, { passive: true });
      slider.addEventListener('touchcancel', finish, { passive: true });
      slider.addEventListener('click', (event) => {
        if (event.detail > 0 && Date.now() < suppressClickUntil) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);
    }

    getItems() {
      try {
        const raw = JSON.parse(localStorage.getItem('cc-recently-viewed') || '[]');
        if (!Array.isArray(raw)) return [];
        return [...new Set(raw.map(String).filter(id => /^[1-9]\d*$/.test(id) && id !== this.dataset.exclude))].slice(0, 12);
      } catch (error) { return []; }
    }

    async init() {
      const items = this.getItems();
      const key = items.join(',');
      if (key === this.lastKey) return;
      this.lastKey = key;
      this.controller?.abort();
      this.controller = new AbortController();
      const controller = this.controller;
      if (!items.length) {
        this.hidden = true;
        this.replaceChildren();
        return;
      }
      try {
        const url = new URL(this.dataset.url, window.location.origin);
        url.searchParams.set('q', items.map(id => `id:${id}`).join(' OR '));
        url.searchParams.set('options[unavailable_products]', 'hide');
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Recently viewed unavailable');
        const template = document.createElement('template');
        template.innerHTML = await response.text();
        if (controller !== this.controller || !this.isConnected) return;
        const source = template.content.querySelector('recently-viewed');
        const grid = source?.querySelector('ul');
        const cards = new Map(Array.from(source?.querySelectorAll('[data-recent-product-id]') || []).map(card => [card.dataset.recentProductId, card]));
        const ordered = items.map(id => cards.get(id)).filter(Boolean).slice(0, Number(this.dataset.limit) || 8);
        if (!grid || !ordered.length) {
          this.hidden = true;
          this.replaceChildren();
          return;
        }
        grid.replaceChildren(...ordered);
        this.replaceChildren(...Array.from(source.childNodes));
        this.hidden = false;
        this.bindTouchScroll();
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.hidden = true;
        this.replaceChildren();
        this.lastKey = undefined;
      }
    }
  }
  customElements.define('recently-viewed', RecentlyViewed);
}

